import { render, staticRenderFns } from "./SupportWaitingList.vue?vue&type=template&id=1895ec96&scoped=true"
import script from "./SupportWaitingList.vue?vue&type=script&lang=js"
export * from "./SupportWaitingList.vue?vue&type=script&lang=js"
import style0 from "./supportList.css?vue&type=style&index=0&id=1895ec96&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1895ec96",
  null
  
)

export default component.exports